
import { Component, Vue } from 'vue-property-decorator'
import StageService from '@/api/services/StageService'

@Component({
})
export default class Home extends Vue {
    protected service = new StageService()

    protected redirectToStage (url: string): void {
        window.location.assign(url)
    }

    async created (): Promise<void> {
        await this.loadStageConnection()
    }

    public async loadStageConnection (): Promise<void> {
        try {
            const response = await this.service.getStageConnection()
            if (typeof response === 'string' && response.length > 0) {
                this.redirectToStage(response)
            }
        } catch (error) {
            console.log(error)
        }
    }
}
